import { __, compose, defaultTo, prop } from 'ramda';
import { withHandlers } from 'recompose';
import cc from 'classcat';

import { fromCents } from '#src/lib/formatters/numbers';
import BorderedRow from '#src/components/BorderedRow';
import Link from '#src/components/Link';

import styles from './styles.module.scss';

const names = {
  PromoOrderItem: 'Promo applied',
  PointsOrderItem: 'Points',
  ChipsOrderItem: 'Chips',
};

const discountLabel = compose(defaultTo(''), prop(__, names), prop('type'));

const Discount = ({
  theme,
  content: { removeDiscountLabel },
  item,
  handleRemove,
}) => (
  <BorderedRow className={cc([styles.discount])}>
    {item.type == 'PromoOrderItem' && (
      <Link theme={theme} onClick={handleRemove}>
        {removeDiscountLabel}
      </Link>
    )}
    <span className={styles.label}>{discountLabel(item)}:</span>
    <span className={styles.value}>{fromCents(item.amount)}</span>
  </BorderedRow>
);

export default withHandlers({
  handleRemove:
    ({ onRemove, item }) =>
    () =>
      onRemove(item.id),
})(Discount);
